import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL, getAuthConfig } from "./shared";

/*
 * Assistant d'onboarding (cahier des charges, section 38). Port de
 * OnboardingModule (frontend/src/pages/HopitalDashboard.js), trimmé pour un
 * établissement labo : "Utilisateurs" pointe sur /api/lab/staff (route
 * dédiée, PR3) et "Types d'actes" sur /api/lab/act-types (route dédiée,
 * PR6c) — toutes deux accessibles à tout rôle labo ayant la permission
 * correspondante, plus seulement au propriétaire de l'établissement.
 */
export default function OnboardingModule({ can, clinicId, setActiveTab }) {
  const storageKey = `tabbibak_labo_onboarding_${clinicId || "default"}`;
  const [checked, setChecked] = useState(() => {
    try { return JSON.parse(localStorage.getItem(storageKey)) || {}; } catch { return {}; }
  });
  const [staffCount, setStaffCount] = useState(null);
  const [actCount, setActCount] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/lab/staff`, getAuthConfig()).then((r) => setStaffCount((r.data.staff || []).length)).catch(() => setStaffCount(0));
    axios.get(`${API_URL}/api/lab/act-types`, getAuthConfig()).then((r) => setActCount((r.data.act_types || []).length)).catch(() => setActCount(0));
  }, []);

  const toggle = (id) => {
    setChecked((c) => {
      const next = { ...c, [id]: !c[id] };
      try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch { /* stockage indisponible : perte silencieuse acceptable ici */ }
      return next;
    });
  };

  const STEPS = [
    { id: "organisation", label: "Organisation", desc: "Nom, wilaya, adresse, téléphone — déjà renseignés à l'inscription.", tab: "overview", done: true },
    { id: "utilisateurs", label: "Utilisateurs", desc: "Ajoutez les membres de votre équipe (secrétariat, prélèvement...).", tab: "staff", done: staffCount === null ? null : staffCount > 1 },
    { id: "horaires", label: "Horaires", desc: "Configurez vos horaires d'ouverture, pauses et capacité simultanée.", tab: "agenda", done: !!checked.horaires, manual: true },
    { id: "actes", label: "Types d'actes", desc: "Créez vos types de prélèvements/analyses (durée, personnel, préparation).", tab: "actes", done: actCount === null ? null : actCount > 0 },
    { id: "notifications", label: "Notifications", desc: "Email et notifications internes sont activées automatiquement, rien à configurer.", tab: null, done: true },
    { id: "integration", label: "Intégration SIL", desc: "Optionnel : connectez votre système métier (webhooks signés).", tab: "integration", done: !!checked.integration, manual: true, optional: true },
    { id: "test", label: "Test", desc: "Créez un patient, faites-le arriver, testez la file d'attente et l'écran préleveur.", tab: "reception", done: !!checked.test, manual: true },
    { id: "production", label: "Mise en production", desc: "Vous êtes prêt : informez votre équipe et commencez à recevoir de vrais patients.", tab: null, done: !!checked.production, manual: true },
  ];
  const doneCount = STEPS.filter((s) => s.done).length;

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0F172A", margin: 0 }}>Mise en route</h1>
      <p style={{ fontSize: 13, color: "#64748B", marginTop: 6 }}>{doneCount} / {STEPS.length} étapes complétées</p>
      <div style={{ background: "#E2E8F0", borderRadius: 8, height: 8, marginTop: 8, overflow: "hidden" }}>
        <div style={{ width: `${(doneCount / STEPS.length) * 100}%`, background: "#185FA5", height: "100%", transition: "width 0.2s" }} />
      </div>

      <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 10 }}>
        {STEPS.map((s, i) => (
          <div key={s.id} style={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: 10, padding: 14, display: "flex", alignItems: "flex-start", gap: 12 }}>
            <div style={{
              width: 26, height: 26, borderRadius: "50%", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
              background: s.done ? "#166534" : "#F1F5F9", color: s.done ? "#fff" : "#94A3B8", fontSize: 13, fontWeight: 700,
            }}>{s.done ? "✓" : i + 1}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#0F172A" }}>
                {s.label}{s.optional && <span style={{ marginLeft: 8, fontSize: 11, color: "#94A3B8", fontWeight: 400 }}>(optionnel)</span>}
              </div>
              <div style={{ fontSize: 13, color: "#64748B", marginTop: 2 }}>{s.desc}</div>
            </div>
            <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
              {s.tab && can && (
                <button onClick={() => setActiveTab(s.tab)} style={{ padding: "6px 12px", background: "#F1F5F9", color: "#334155", border: "none", borderRadius: 8, fontSize: 12, cursor: "pointer" }}>Ouvrir</button>
              )}
              {s.manual && (
                <button onClick={() => toggle(s.id)} style={{ padding: "6px 12px", background: s.done ? "#DCFCE7" : "#185FA5", color: s.done ? "#166534" : "#fff", border: "none", borderRadius: 8, fontSize: 12, cursor: "pointer" }}>
                  {s.done ? "Fait" : "Marquer fait"}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
